<template>
  <div>
    <form @submit.prevent="pressOk">
      <div class="row">
        <div class="col">
          <div class="form-group">
            <strong>Variedad</strong>
            <v-select :options="varieties" v-model="variety" @input="changeVarietyPercent(variety, percent)"> 
              <span slot="no-options">No se encontraron Variedades</span>
            </v-select><br>
            <strong>%</strong>
            <input type="number" class="form-control" min="0" max="100" v-model="percent" @input="changeVarietyPercent(variety, percent)"/>
            <button class="btn btn-block btn-success mt-2" type="button" @click="AddVariety(variety, percent)" :disabled="BtnAddDisabled">
              <i class="fa fa-plus"></i>
              Agregar
            </button>
          </div>
          <div class="form-group">
            <table class="table table-striped table-hover table-bordered" >
            <thead class="thead-dark" >
              <tr>
                <th>Variedad</th>
                <th>%</th>
                <th>Opciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(tableVariety, index) of newComposition" :key="index">
                <td>{{tableVariety.variety}}</td>
                <td>{{tableVariety.percent}}</td>
                <td style="text-align: center; width: 30px"><button type="button" title="Eliminar Item en Mezcla" class="btn btn-danger  " @click="deleteItemMix(index)" data-toggle="tooltip" data-placement="top">
                        <i class="fas fa-trash"></i>
                    </button>
                </td>
              </tr>
            </tbody>
          </table>
          </div>
          <div class="form-group">
            <strong>% Mezcla Total</strong>
            <span v-if="valueTotal==100">
              <b-progress :max="max" height="2rem">
                  <b-progress-bar :value="valueTotal" @input="changeTable()" variant="success">
                      <strong>{{ valueTotal }}% / {{ max }}%</strong>
                  </b-progress-bar>
              </b-progress>
            </span>
            <span v-else>
              <b-progress :max="max" height="2rem">
                <b-progress-bar :value="valueTotal" @input="changeTable()" variant="primary">
                    <strong>{{ valueTotal }}% / {{ max }}%</strong>
                </b-progress-bar>
              </b-progress>
            </span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <button class="btn btn-block btn-success" :disabled="BtnSaveDisabled">
              <i class="fa fa-save"></i>
              Aceptar
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import { Post, Get } from "../../helper/axios.js";
import toastr from "toastr";
export default {
  data() {
    return {
      apiUrl: this.$store.getters.apiUrl,
      Post,
      Get,
      varieties: [],
      variety: '',
      percent:0,
      valueTotal: 0,
      max:100,
      tableVarieties: [],
      ListItem: 1,
      BtnAddDisabled: true,
      BtnSaveDisabled: true,
      newComposition: []
    };
  },
  created() {
      this.getVariety()
  },

  methods: {
    pressOk() {
      this.SumTablePercent();
        var valid = true;
        var message = "Corrija los siguiente:<br>";
        if (this.valueTotal<100) {
          message = message + "* La Composicion no esta al 100%.<br>";
          valid = false;
        }
        if (valid) {
          this.$emit("pressOk");
          
        } else {
          toastr.info(message);
        }
    },
    getVariety() {
      this.$store.commit("setLoading", true);
            this.Get(`${this.apiUrl}v1/varieties/`, (res) => {
                    this.varieties = [];
                    res.data.forEach(item => {
                        this.varieties.push({
                            code: item.varietyCode,
                            label: item.varietyDescription
                        });
                    });
                    this.$store.commit("setLoading", false);
                });
    },
    AddVariety(){
        var exist=false;
        if((this.percent<=100 && this.valueTotal<=100) && this.valueTotal + parseInt(this.percent) <= 100){
            if(this.newComposition.length>0){
                this.newComposition.forEach(element => {
                    if(element.variety == this.variety.label){
                        element.percent = parseInt(element.percent) + parseInt(this.percent)
                        exist=true;
                    }                        
                });
            }
            if(exist==false){
                this.newComposition.push({
                    variety: this.variety.label,
                    percent: parseInt(this.percent),
                    RequestCommercialSampleDetailId: null
                });
            }
            this.SumTablePercent();
        }
        else{
            toastr.info("Porcentaje de variedad y del total debe ser menor a 100 ");
        }
        this.resetfield();
        this.changeVarietyPercent(this.variety, this.percent);
        this.changeTable();        
    },
    deleteItemMix(index){
        this.newComposition.splice(index, 1);
        this.SumTablePercent();
        this.changeTable();
        this.resetfield();
        this.changeVarietyPercent(index, this.percent);
    },
    changeVarietyPercent(variety, percent){
        if(variety!=undefined && variety!='' && percent>0)
            this.BtnAddDisabled = false;
        else
            this.BtnAddDisabled = true;
    },
    changeTable(){
        if(this.valueTotal==100)
            this.BtnSaveDisabled=false
        else
            this.BtnSaveDisabled=true
    },
    SumTablePercent(){
        this.valueTotal =0;
         this.newComposition.forEach(element => {
            this.valueTotal = parseInt(this.valueTotal) + parseInt(element.percent);
        });
    },
    resetfield(){
        this.variety='';
        this.percent=0;
    }
    
},
mounted(){
  this.$emit('newComposition',this.newComposition);
}
};
</script>


